import { NgModule } from '@angular/core';
import {Router, RouterModule} from '@angular/router';
import {ScenariosCoreModule} from '@features/scenarios-core/scenarios-core.module';
import {
  cbcRoutes,
  txpRoutes,
  globalMinimumTaxRoutes,
  itcRoutes, pcbcRoutes
} from '@features/global-tax-calculator/global-tax-calculator.routes';
import {CommandService} from '@core/services/command.service';
import {PlatformApiProvider} from '@shared/services/platform-api-provider';
import {PlatformCommand} from '@shared/commands/command-base';
import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {PlatformToolItcDesktopHandler} from '@features/global-tax-calculator/services/platform-tool-itc-desktop.handler';
import {GlobalTaxCalculatorDynamicComponentHelper} from '@features/global-tax-calculator/global-tax-calculator-dynamic-component-helper';
import { GtcLibraryComponent } from './components/gtc-library/gtc-library.component';
import {CommonModule} from '@angular/common';
import {SharedModule} from '@shared/shared.module';
import {GlobalTaxCalculatorServices} from '@features/global-tax-calculator/services/global-tax-calculator.services';
import {GtcPlanningCommandHandler} from '@features/global-tax-calculator/services/gtc-planning-command-handler';
import {GtcPlanningScenarioCommandHandler} from '@features/global-tax-calculator/services/gtc-planning-scenario-command-handler';
import {DataExtractorHandler} from '@features/global-tax-calculator/services/data-extractor-handler';
import { AnalyticReportHandler } from './services/analytic-report-handler';
import {
  CbCApiProvider, DashboardApiProvider,
  GmtApiProvider,
  ItcApiProvider,
  TaxProvisionApiProvider, PCbCApiProvider
} from './services/global-tax-calculator-api-provider';
import {
  GtcAnalyticsTileListComponent
} from '@features/global-tax-calculator/components/gtc-analytics-tile-list-component/gtc-analytics-tile-list-component.component';
import { UpdateAnalyticReportFromTemplateCommandHandler } from './services/update-analytic-report-from-template-command.handler';
import { GtcScenariosTileListComponent } from './components/gtc-scenarios-tile-list/gtc-scenarios-tile-list.component';
import { GtcScenarioTagsComponent } from './components/gtc-scenario-tags/gtc-scenario-tags.component';
import {ScenarioHandler} from '@features/global-tax-calculator/services/scenario.handler';
import {PlatformToolDac6LibraryHandler} from "@features/dac6-reporter/services/platform-tool-dac6-library.handler";
import {Api} from "@shared/constants/common-field.constants";
import {PlatformToolGmtChaptersHandler} from '@features/global-tax-calculator/command-handlers/platform-tool-gmt-chapters.handler';
import {PlatformToolGmtChaptersContentHandler} from '@features/global-tax-calculator/command-handlers/platform-tool-gmt-chapters-content-handler';
import { ChapterTileViewComponent } from './components/chapter-tile-view/chapter-tile-view.component';
import { AnalyticReportTemplateHandler } from './services/analytic-report-template-handler';
import {PlatformToolGmtCountryAnalysisHandler} from '@features/global-tax-calculator/command-handlers/platform-tool-gmt-country-analysis-handler';
import {PlatformToolGmtCountryAnalysisContentHandler} from '@features/global-tax-calculator/command-handlers/platform-tool-gmt-country-analysis-content-handler';
import {CbcScenarioHandler} from "@features/global-tax-calculator/services/cbc-scenario-handler.service";
import {BrowserModule} from "@angular/platform-browser";
import { CbcNotificationRequiredDialogEditorComponent } from './components/cell-editor/cbc-compliance/cbc-notification-required-dialog-editor/cbc-notification-required-dialog-editor.component';
import { CbcCommonEditCellViewerComponent } from './components/cell-viewer/cbc-compliance/cbc-common-edit-cell-viewer/cbc-common-edit-cell-viewer.component';
import { CbcAutoExchangeDialogEditorComponent } from './components/cell-editor/cbc-compliance/cbc-auto-exchange-dialog-editor/cbc-auto-exchange-dialog-editor.component';
import {
  CbcLocalEntityRequiredFileEditorComponent,
} from './components/cell-editor/cbc-compliance/cbc-localentity-required-file-editor/cbc-localentity-required-file-editor.component';
import { NoteCellViewerComponent } from './components/cell-viewer/cbc-compliance/note-cell-viewer/note-cell-viewer.component';
import { NoteDialogEditorComponent } from './components/cell-editor/cbc-compliance/note-dialog-editor/note-dialog-editor.component';
import {ScenarioCountryCalculatorHandler} from "@features/global-tax-calculator/services/scenario-country-calculator-handler";
import { CbcRequiredEditCellViewerComponent } from './components/cell-viewer/cbc-compliance/cbc-required-edit-cell-viewer/cbc-required-edit-cell-viewer.component';
import { CbcRequiredEditComponent } from './components/cbc-required-edit/cbc-required-edit.component';
import { JurisdictionCellViewerComponent } from './components/cell-viewer/cbc-compliance/jurisdiction-cell-viewer/jurisdiction-cell-viewer.component';
import { DownloadMemoCellViewerComponent } from './components/cell-viewer/cbc-compliance/download-memo-cell-viewer/download-memo-cell-viewer.component';
import { CbcTlLetterCellViewerComponent } from './components/cell-viewer/cbc-compliance/cbc-tl-letter-cell-viewer/cbc-tl-letter-cell-viewer.component';
import {ScenarioCalculatorHandler} from "@features/global-tax-calculator/services/scenario-calculator-handler";
import {CbCFilingHandler} from "@features/global-tax-calculator/services/cbc-filing-handler";
import {CbcFormsHandler} from '@features/global-tax-calculator/services/cbc-forms-handler';
import {DownloadPlatformFormErrorCommandHandler} from '@features/global-tax-calculator/services/download-platform-form-error-command-handler';
import { CbcStringCellViewerComponent } from './components/cell-viewer/cbc-filing/cbc-string-cell-viewer/cbc-string-cell-viewer.component';
import { CbcMasterFileRequiredDialogEditorComponent } from './components/cell-editor/cbc-compliance/cbc-master-file-required-dialog-editor/cbc-master-file-required-dialog-editor.component';
import { CbcLocalFileRequiredDialogEditorComponent } from './components/cell-editor/cbc-compliance/cbc-local-file-required-dialog-editor/cbc-local-file-required-dialog-editor.component';
import {DownloadCbCFormReportCommandHandler} from '@features/global-tax-calculator/services/download-cbc-form-report-command-handler';
import {EditDateSettingsDialogEditorComponent} from "@features/global-tax-calculator/components/edit-date-settings-dialog-editor/edit-date-settings-dialog-editor.component";
import { CbcDateFiledCellViewerComponent } from './components/cell-viewer/cbc-filing/cbc-date-filed-cell-viewer/cbc-date-filed-cell-viewer.component';
import { PlatformToolCbcDateFiledCardComponent } from './cards/platform-tool-cbc-date-filed-card/platform-tool-cbc-date-filed-card.component';
import { ConfirmationReceiptCellViewerComponent } from './components/cell-viewer/cbc-filing/confirmation-receipt-cell-viewer/confirmation-receipt-cell-viewer.component';
import { DiagnosticReportComponent } from './components/diagnostic-report/diagnostic-report.component';
import { GtcHyperlinkCellViewerComponent } from './components/cell-viewer/gtc-hyperlink-cell-viewer/gtc-hyperlink-cell-viewer.component';
import { DiagnosticReportMismatchedRecordDetailsComponent } from './components/diagnostic-report-mismatched-record-details/diagnostic-report-mismatched-record-details.component';
import { DiagnosticReportContainerComponent } from './components/diagnostic-report-container/diagnostic-report-container.component';
import {DiagnosticReportService} from '@features/global-tax-calculator/services/diagnostic-report.service';
import { ShowCountryCalculatorsDialogComponent } from './components/show-country-calculators-dialog/show-country-calculators-dialog.component';
import { CountryTrackerComparisonComponent } from './components/country-tracker-comparison/country-tracker-comparison.component';
import {ScenarioWorkflowHandler} from '@features/global-tax-calculator/services/scenario-workflow-handler';
import {DynamicRoutesService} from "@shared/services/dynamic-routes.service";
import { ScenarioDynamicItemsComponent } from './components/scenario-dynamic-items/scenario-dynamic-items.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { OrbitaxEntityDesignerModule } from '@features/entity-designer/orbitax-entity-designer.module';
import { TxpSettingsComponent } from './components/txp-settings/txp-settings.component';
import { CbcExchangeStatusComponent } from './components/cbc-exchange-status/cbc-exchange-status.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CbcCommentaryTaxInformationComponent } from './components/cbc-commentary-tax-information/cbc-commentary-tax-information.component';
import { CbcConventionMutualInformationComponent } from './components/cbc-convention-mutual-information/cbc-convention-mutual-information.component';
import { CbcEuAdministrativeCooperationTaxationComponent } from './components/cbc-eu-administrative-cooperation-taxation/cbc-eu-administrative-cooperation-taxation.component';
import { CbcModelAgreementTaxMattersComponent } from './components/cbc-model-agreement-tax-matters/cbc-model-agreement-tax-matters.component';
import { CbcExchangeFilterSelectComponent } from './components/cbc-exchange-filter-select/cbc-exchange-filter-select.component';
import { ScenarioFormValidationErrorComponent } from './components/scenario-form-validation-error/scenario-form-validation-error.component';
@NgModule({
  declarations: [
       GtcLibraryComponent,
    GtcAnalyticsTileListComponent,
    GtcScenariosTileListComponent,
    GtcScenarioTagsComponent,
    ChapterTileViewComponent,
    CbcNotificationRequiredDialogEditorComponent,
    CbcCommonEditCellViewerComponent,
    CbcAutoExchangeDialogEditorComponent,
    CbcLocalEntityRequiredFileEditorComponent,
    NoteCellViewerComponent,
    NoteDialogEditorComponent,
    CbcRequiredEditCellViewerComponent,
    CbcDateFiledCellViewerComponent,
    CbcTlLetterCellViewerComponent,
    CbcRequiredEditComponent,
    JurisdictionCellViewerComponent,
    DownloadMemoCellViewerComponent,
    CbcStringCellViewerComponent,
    CbcMasterFileRequiredDialogEditorComponent,
    CbcLocalFileRequiredDialogEditorComponent,
    EditDateSettingsDialogEditorComponent,
    PlatformToolCbcDateFiledCardComponent,
    ConfirmationReceiptCellViewerComponent,
    DiagnosticReportComponent,
    GtcHyperlinkCellViewerComponent,
    DiagnosticReportMismatchedRecordDetailsComponent,
    DiagnosticReportContainerComponent,
    ShowCountryCalculatorsDialogComponent,
    CountryTrackerComparisonComponent,
    ScenarioDynamicItemsComponent,
    TxpSettingsComponent,
    CbcExchangeStatusComponent,
    CbcCommentaryTaxInformationComponent,
    CbcConventionMutualInformationComponent,
    CbcEuAdministrativeCooperationTaxationComponent,
    CbcModelAgreementTaxMattersComponent,
    CbcExchangeFilterSelectComponent,
    ScenarioFormValidationErrorComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    SharedModule,
    RouterModule.forChild(itcRoutes),
    RouterModule.forChild(globalMinimumTaxRoutes),
    RouterModule.forChild(cbcRoutes),
    RouterModule.forChild(txpRoutes),
    RouterModule.forChild(pcbcRoutes),
    ScenariosCoreModule,
    FormsModule,
    ReactiveFormsModule,
    OrbitaxEntityDesignerModule,
    MatExpansionModule,
    MatTooltipModule
  ],
  providers: [
    GlobalTaxCalculatorServices,
    DiagnosticReportService
  ]
})
export class GlobalTaxCalculatorModule {
  constructor(private commandService: CommandService,
              private platformApiProvider: PlatformApiProvider,
              private platformToolItcDesktopHandler: PlatformToolItcDesktopHandler,
              private platformToolDac6LibraryHandler: PlatformToolDac6LibraryHandler,
              private gtcPlanningCommandHandler: GtcPlanningCommandHandler,
              private gtcPlanningScenarioCommandHandler: GtcPlanningScenarioCommandHandler,
              private analyticReportHandler: AnalyticReportHandler,
              private dataExtractorHandler: DataExtractorHandler,
              private updateAnalyticReportFromTemplateCommandHandler: UpdateAnalyticReportFromTemplateCommandHandler,
              private scenarioHandler: ScenarioHandler,
              private platformToolGmtChaptersHandler: PlatformToolGmtChaptersHandler,
              private platformToolGmtChaptersContentHandler: PlatformToolGmtChaptersContentHandler,
              private analyticReportTemplateHandler: AnalyticReportTemplateHandler,
              private platformToolGmtCountryAnalysisHandler: PlatformToolGmtCountryAnalysisHandler,
              private platformToolGmtCountryAnalysisContentHandler: PlatformToolGmtCountryAnalysisContentHandler,
              private scenarioCountryCalculatorHandler: ScenarioCountryCalculatorHandler,
              private scenarioCalculatorHandler: ScenarioCalculatorHandler,
              private cbcScenarioHandler: CbcScenarioHandler,
              private cbcFilingHandler: CbCFilingHandler,
              private cbcFormsHandler: CbcFormsHandler,
              private downloadPlatformFormErrorCommandHandler: DownloadPlatformFormErrorCommandHandler,
              private downloadCbCFormReportCommandHandler: DownloadCbCFormReportCommandHandler,
              private scenarioWorkflowHandler: ScenarioWorkflowHandler,
              private dynamicRoutesService: DynamicRoutesService
  ) {
    GlobalTaxCalculatorDynamicComponentHelper.init();
    GlobalTaxCalculatorDynamicComponentHelper.register('PlatformToolDac6LibraryHandler', platformToolDac6LibraryHandler);
    GlobalTaxCalculatorDynamicComponentHelper.register('PlatformToolGmtChaptersHandler', platformToolGmtChaptersHandler);
    GlobalTaxCalculatorDynamicComponentHelper.register('PlatformToolGmtChaptersContentHandler', platformToolGmtChaptersContentHandler);
    GlobalTaxCalculatorDynamicComponentHelper.register('ScenarioHandler', scenarioHandler);
    GlobalTaxCalculatorDynamicComponentHelper.register('PlatformToolGmtCountryAnalysisHandler', platformToolGmtCountryAnalysisHandler);
    GlobalTaxCalculatorDynamicComponentHelper.register('PlatformToolGmtCountryAnalysisContentHandler', platformToolGmtCountryAnalysisContentHandler);
    GlobalTaxCalculatorDynamicComponentHelper.register('CbcScenarioHandler', cbcScenarioHandler);
    GlobalTaxCalculatorDynamicComponentHelper.register('CbCFilingHandler', cbcFilingHandler);
    GlobalTaxCalculatorDynamicComponentHelper.register('CbcFormsHandler', cbcFormsHandler);
    GlobalTaxCalculatorDynamicComponentHelper.register('ScenarioCountryCalculatorHandler', scenarioCountryCalculatorHandler);
    GlobalTaxCalculatorDynamicComponentHelper.register('ScenarioCalculatorHandler', scenarioCalculatorHandler);
    GlobalTaxCalculatorDynamicComponentHelper.register('DownloadPlatformFormErrorCommandHandler', downloadPlatformFormErrorCommandHandler);
    GlobalTaxCalculatorDynamicComponentHelper.register('DownloadCbCFormReportCommandHandler', downloadCbCFormReportCommandHandler);
    GlobalTaxCalculatorDynamicComponentHelper.register('ScenarioWorkflowHandler', scenarioWorkflowHandler);


    this.commandService.registrPlatformLinkCommand('/gmt/scenarios', this.getCreateScenarioToolLinkCommand('GMT'));
    this.commandService.registrPlatformLinkCommand('/gmt/scenarios/filter', this.getCreateScenarioToolLinkCommand('GMT','ScenarioFilter'));
    this.commandService.registrPlatformLinkCommand('/gmt/scenarios/form/:FormId', this.getGMTFilingFormPlatformLinkCommand());
    this.commandService.registrPlatformLinkCommand('/cbc/scenarios', this.getCreateScenarioToolLinkCommand('CbC'));
    this.commandService.registrPlatformLinkCommand('/cbc/scenarios/filter', this.getCreateScenarioToolLinkCommand('CbC','ScenarioFilter'));
    this.commandService.registrPlatformLinkCommand('/itc/scenarios', this.getCreateScenarioToolLinkCommand('ITC'));
    this.commandService.registrPlatformLinkCommand('/itc/scenarios/filter', this.getCreateScenarioToolLinkCommand('ITC','ScenarioFilter'));
    this.commandService.registrPlatformLinkCommand('/txp/scenarios', this.getCreateScenarioToolLinkCommand('TXP'));
    this.commandService.registrPlatformLinkCommand('/txp/scenarios/filter', this.getCreateScenarioToolLinkCommand('TXP','ScenarioFilter'));
    this.commandService.registrPlatformLinkCommand('/pcbc/scenarios', this.getCreateScenarioToolLinkCommand('PCbC'));
    this.commandService.registrPlatformLinkCommand('/pcbc/scenarios/filter', this.getCreateScenarioToolLinkCommand('PCbC','ScenarioFilter'));
    this.commandService.registrPlatformLinkCommand('/txp/configuration', this.getTxpAdminPanelToolLinkCommand());
    this.commandService.registrPlatformLinkCommand('/cbc/compliance', this.GetCreateCbCComplianceToolLinkCommand('CbC'));
    this.commandService.registrPlatformLinkCommand('/cbc/supported-countries', this.GetCreatCbcSupportedCountriesToolLinkCommand('CbC'));
    this.commandService.registrPlatformLinkCommand('/cbc/forms', this.GetCBCFormsToolLinkCommand('CbC'));
    this.commandService.registrPlatformLinkCommand('/cbc/scenarios/form/:FormId', this.getPublicCbCFormPlatformLinkCommand());
    this.commandService.registrPlatformLinkCommand('/cbc/filing', this.GetCreateCbCFilingToolLinkCommand('CbC'));
    this.commandService.registrPlatformLinkCommand('/cbc/compliance/changes', this.GetCbcComplianceCommand('CbC'));
    this.commandService.registrPlatformLinkCommand('/gmt/scenarios/otp', this.getCreateOtpDataPlatformToolLinkCommandConsumer('GMT'));
    this.commandService.registrPlatformLinkCommand('/eat/txp', this.getCreateWorkflowPlatformToolLinkCommandConsumer('TXP'));
    let command = new PlatformCommand('CreatePlanningToolLinkCommand', 'SpreadsheetApi');
    command.projectId = '[PROJECT_ID]';
    this.commandService.registrPlatformLinkCommand('/gtc/planning', command);
    command = new PlatformCommand('CreatePlanningToolLinkCommand', 'SpreadsheetApi');
    command.projectId = '[PROJECT_ID]';
    command.fieldValues['ScenarioType'] = 'GMT';
    this.commandService.registrPlatformLinkCommand('/gmt/planning', command);


    this.commandService.registrPlatformLinkCommand('/gmt/scenarios/add-filter/:platformLinkId', this.SelectScenarioContentsCommand('GMT'));
    this.commandService.registrPlatformLinkCommand('/cbc/scenarios/add-filter/:platformLinkId', this.SelectScenarioContentsCommand('CbC'));
    this.commandService.registrPlatformLinkCommand('/itc/scenarios/add-filter/:platformLinkId', this.SelectScenarioContentsCommand('ITC'));
    this.commandService.registrPlatformLinkCommand('/txp/scenarios/add-filter/:platformLinkId', this.SelectScenarioContentsCommand('TXP'));

    this.commandService.registrPlatformLinkCommand('/gmt/analytics', this.getAnalyticReportToolLinkCommand('GMT','GMTAnalyticReportToolLinkCommand'));
    this.commandService.registrPlatformLinkCommand('/cbc/analytics', this.getAnalyticReportToolLinkCommand('CbC','CbCAnalyticReportToolLinkCommand'));

    this.commandService.registrPlatformLinkCommand('/gmt/library/taxnews', this.getGmtTaxNewsToolLinkCommand());

    this.commandService.registrPlatformLinkCommand('/cbc/library/taxnews', this.getGmtTaxNewsFromCBCToolLinkCommand(Api.Spreadsheet));
    this.commandService.registrPlatformLinkCommand('/cbc/library/oecd-materials', this.getCbCOECDMaterialsToolLinkCommand('cbc_oecd', "CbCApi"));
    this.commandService.registrPlatformLinkCommand('/cbc/library/oecd-materials/:countryCode',this.getCbcChapterDocumentViewerToolLinkCommand("CbCApi", 'cbc_oecd'));
    this.commandService.registrPlatformLinkCommand('/cbc/library/oecd-materials/:countryCode/:categoryId',this.getCbcChapterDocumentViewerToolLinkCommand("CbCApi", 'cbc_oecd'));
    this.commandService.registrPlatformLinkCommand('/cbc/library/eu-materials', this.getCbCEUDMaterialsToolLinkCommand('cbc_eu', "CbCApi"));
    this.commandService.registrPlatformLinkCommand('/cbc/library/eu-materials/:countryCode',this.getCbcChapterDocumentViewerToolLinkCommand("CbCApi", 'cbc_eu'));
    this.commandService.registrPlatformLinkCommand('/cbc/library/eu-materials/:countryCode/:categoryId',this.getCbcChapterDocumentViewerToolLinkCommand("CbCApi", 'cbc_eu'));
    this.commandService.registrPlatformLinkCommand('/cbc/library/exchange', this.getCbCExchangeToolLinkCommand());

    // this.commandService.registrPlatformLinkCommand('/cbc/analytics', this.getAnalyticReportToolLinkCommand('CbC'));
    // this.commandService.registrPlatformLinkCommand('/itc/analytics', this.getAnalyticReportToolLinkCommand('ITC'));
    let masonryCommand = new PlatformCommand("CreateMasonryToolLinkCommand", Api.Visualizer);
    this.commandService.registrPlatformLinkCommand('/dashboard/gmt', masonryCommand);

    this.commandService.registrPlatformLinkCommand('/gmt/dashboard', this.getDashboardDesignLinkCommand('/gmt/dashboard', 'Global Minimum Tax'));
    this.commandService.registrPlatformLinkCommand('/cbc/dashboard', this.getDashboardDesignLinkCommand('/cbc/dashboard', 'CbC Compliance & Reporting'));
    this.commandService.registrPlatformLinkCommand('/itc/dashboard', this.getDashboardDesignLinkCommand('/itc/dashboard', 'International Tax Calculator'));

    // this.commandService.registrPlatformLinkCommand('/cbc/analytics', this.getAnalyticReportToolLinkCommand('CbC'));

    this.commandService.registrPlatformLinkCommand('/gmt/library/summary-rules', this.getGMTSummaryRuleCommand('CreateSummaryRulesToolLinkCommand'));
    // this is for magic link - used `eat` here because without `eat` can't use `MAGIC-LINK-ONLY` feature
    this.commandService.registrPlatformLinkCommand('/eat/gmt/library/summary-rules', this.getGMTSummaryRuleCommand('CreateSummaryRulesToolLinkCommand',true));

    this.commandService.registrPlatformLinkCommand('/gmt/library/country-heatmap', this.getGmtHeatmapToolLinkCommand(Api.Spreadsheet));
    this.commandService.registrPlatformLinkCommand('/gmt/library/oecd-materials', this.getGmtChapterToolLinkCommand('oecd'));
    this.commandService.registrPlatformLinkCommand('/gmt/library/oecd-materials/:countryCode',
      this.getGmtChapterDocumentViewerToolLinkCommand('oecd'));
    this.commandService.registrPlatformLinkCommand('/gmt/library/oecd-materials/:countryCode/:categoryId',
      this.getGmtChapterDocumentViewerToolLinkCommand('oecd'));

    this.commandService.registrPlatformLinkCommand('/gmt/library/country-materials', this.getGmtCountryMaterialsToolLinkCommand('country'));
    this.commandService.registrPlatformLinkCommand('/gmt/library/country-materials/:countryCode',
      this.getGmtChapterToolLinkCommand('country'));
    this.commandService.registrPlatformLinkCommand('/gmt/library/country-materials/:countryCode/:categoryId',
      this.getGmtChapterDocumentViewerToolLinkCommand('country'));

    this.commandService.registrPlatformLinkCommand('/gmt/library/reference-materials', this.getGmtChapterToolLinkCommand('reference'));
    this.commandService.registrPlatformLinkCommand('/gmt/library/reference-materials/:countryCode',
      this.getGmtChapterDocumentViewerToolLinkCommand('reference'));
    this.commandService.registrPlatformLinkCommand('/gmt/library/reference-materials/:countryCode/:categoryId',
      this.getGmtChapterDocumentViewerToolLinkCommand('reference'));

    this.commandService.registrPlatformLinkCommand('/gmt/library/country-analysis', this.getGmtCountryAnalysisToolLinkCommand());
    this.commandService.registrPlatformLinkCommand('/gmt/library/country-analysis/:countryCode', this.getGmtCountryAnalysisDocumentViewerToolLinkCommand());
    this.commandService.registrPlatformLinkCommand('/gmt/library/country-analysis/:countryCode/:categoryId', this.getGmtCountryAnalysisDocumentViewerToolLinkCommand());
    this.commandService.registrPlatformLinkCommand('/gmt/library/country-analysis/comparison', this.getGmtCountryAnalysisComparisonToolLinkCommand());

    RootDynamicComponentHelper.register('PlatformToolItcDesktopHandler', platformToolItcDesktopHandler);
    RootDynamicComponentHelper.register('GtcPlanningCommandHandler', gtcPlanningCommandHandler);
    RootDynamicComponentHelper.register('GtcPlanningScenarioCommandHandler', gtcPlanningScenarioCommandHandler);
    RootDynamicComponentHelper.register('AnalyticReportHandler', analyticReportHandler);
    RootDynamicComponentHelper.register('DataExtractorHandler', dataExtractorHandler);
    RootDynamicComponentHelper.register('UpdateAnalyticReportFromTemplateCommandHandler', updateAnalyticReportFromTemplateCommandHandler);
    RootDynamicComponentHelper.register('AnalyticReportTemplateHandler', analyticReportTemplateHandler);


    this.platformApiProvider.registerAtTop(new GmtApiProvider());
    this.platformApiProvider.registerAtTop(new ItcApiProvider());
    this.platformApiProvider.registerAtTop(new TaxProvisionApiProvider());
    this.platformApiProvider.registerAtTop(new CbCApiProvider());
    this.platformApiProvider.registerAtTop(new PCbCApiProvider());
    this.platformApiProvider.registerAtTop(new DashboardApiProvider());


  }

  private SelectScenarioContentsCommand(scenarioType: string){
    let command = new PlatformCommand('SelectScenarioContentsToolLinkCommand', 'SpreadsheetApi');
    command.setValue("ScenarioType", scenarioType);
    return command;
  }

  private getDashboardDesignLinkCommand(path: string, solution: string): PlatformCommand {
    const command = new PlatformCommand('OpenSolutionDefaultDashboardCommand', Api.IntelliCanvasApi);
    command.waitForResponse = true;
    command.projectId = '[PROJECT_ID]';
    command.fieldValues['Solution'] = solution;
    command.fieldValues['DesignMode'] = false;
    command.fieldValues['IgnoreRedirectUrl'] = true;
    return command;
  }

  private getAnalyticReportToolLinkCommand(scope: string, commandName:string) {
    const command = new PlatformCommand(commandName, 'VisualizerApi');
    command.fieldValues['Scope'] = scope;
    // command.fieldValues['ScenarioType'] = scope;
    return command;
  }


  private getGmtHeatmapToolLinkCommand(api: string) {
    const command = new PlatformCommand('GmtLibraryCountryHeatmapCommand', Api.Chapters);
    command.fieldValues['MenuApi'] = api;
    return command;
  }

  private getGmtTaxNewsToolLinkCommand() {
    const gmtTaxNewsCommand = new PlatformCommand('GMTTaxNewsToolLinkCommand', 'TaxNewsApi');
    gmtTaxNewsCommand.projectId = '[PROJECT_ID]';
    gmtTaxNewsCommand.fieldValues['PageNo'] = 0;
    return gmtTaxNewsCommand;
  }
  private getGmtTaxNewsFromCBCToolLinkCommand(api: string) {
    const gmtTaxNewsCommand = new PlatformCommand('GMTTaxNewsToolLinkCommand', 'TaxNewsApi');
    gmtTaxNewsCommand.projectId = '[PROJECT_ID]';
    gmtTaxNewsCommand.fieldValues['MenuApi'] = api;
    return gmtTaxNewsCommand;
  }

  private getCbCOECDMaterialsToolLinkCommand(documentCategory: string, api: string) {
    const command = new PlatformCommand('GmtChapterToolLinkCommand', Api.Chapters);
    command.fieldValues['ViewType'] = 'TileView';
    command.fieldValues['DocumentCategory'] = documentCategory;
    command.fieldValues['MenuApi'] = api;
    command.fieldValues['Category'] = "CbC OECD Materials";
    return command;
  }
   private getCbCEUDMaterialsToolLinkCommand(documentCategory: string, api: string) {
    const command = new PlatformCommand('GmtChapterToolLinkCommand', Api.Chapters);
    command.fieldValues['ViewType'] = 'TileView';
    command.fieldValues['DocumentCategory'] = documentCategory;
    command.fieldValues['MenuApi'] = api;
    command.fieldValues['Category'] = "CbC EU Materials";
    return command;
  }

  private getCbcChapterDocumentViewerToolLinkCommand(api: string, documentCategory: string) {
    const command = new PlatformCommand('GmtChapterDocumentViewerToolLinkCommand', Api.Chapters);
    command.fieldValues['MenuApi'] = api;
    command.fieldValues['DocumentCategory'] = documentCategory;
    return command;
  }
  private getCbCExchangeToolLinkCommand() {
    var command = new PlatformCommand('CbcExchangeToolLinkCommand', Api.Chapters);
    command.projectId = '[PROJECT_ID]';
    return command;
  }
  private getCreateScenarioToolLinkCommand(scenarioType: string, tabName: string = '') {
    const command = new PlatformCommand('CreateScenarioToolLinkCommand', 'SpreadsheetApi');
    command.projectId = '[PROJECT_ID]';
    command.waitForResponse = true;
    if (scenarioType && scenarioType.length) {
      command.fieldValues['ScenarioType'] = scenarioType;
    }
    if(tabName==="ScenarioFilter") {
      command.fieldValues['TabName'] = tabName;
    }
    return command;
  }

  private GetCreateCbCComplianceToolLinkCommand(scenarioType: string) {
    const command = new PlatformCommand('CreateCbCComplianceToolLinkCommand', Api.DueDateTracker);
    command.projectId = '[PROJECT_ID]';
    if (scenarioType && scenarioType.length) {
      command.fieldValues['ScenarioType'] = scenarioType;
    }
    return command;
  }
  private GetCBCFormsToolLinkCommand(scenarioType: string) {
    const command = new PlatformCommand('CBCFormsToolLinkCommand', Api.Spreadsheet);
    command.projectId = '[PROJECT_ID]';
    if (scenarioType && scenarioType.length) {
      command.fieldValues['ScenarioType'] = scenarioType;
    }
    return command;
  }

  private getGMTSummaryRuleCommand(commandName: string, isMagicLink: boolean = false) {
    const command = new PlatformCommand(commandName, Api.Chapters);
    command.fieldValues['SourceType'] = 'GMTSummaryRule';
    command.fieldValues['MenuApi'] = Api.Spreadsheet;
    command.fieldValues['IsMagicLink'] = isMagicLink;
    return command;
  }

  private getGmtChapterToolLinkCommand(documentCategory: string) {
    const command = new PlatformCommand('GmtChapterToolLinkCommand', Api.Chapters);
    command.fieldValues['ViewType'] = 'TileView';
    command.fieldValues['DocumentCategory'] = documentCategory;
    return command;
  }

  private getGmtCountryMaterialsToolLinkCommand(documentCategory: string) {
    const command = new PlatformCommand('GmtCountryMaterialsToolLinkCommand', Api.Chapters);
    command.fieldValues['ViewType'] = 'TileView';
    command.fieldValues['DocumentCategory'] = documentCategory;
    return command;
  }

  private getGmtChapterDocumentViewerToolLinkCommand(documentCategory: string) {
    const command = new PlatformCommand('GmtChapterDocumentViewerToolLinkCommand', Api.Chapters);
    command.fieldValues['DocumentCategory'] = documentCategory;
    return command;
  }

  private getGmtCountryAnalysisToolLinkCommand() {
    const command = new PlatformCommand('GmtCountryAnalysisToolLinkCommand', Api.Chapters);
    command.fieldValues['ViewType'] = 'TileView';
    return command;
  }

  private getGmtCountryAnalysisDocumentViewerToolLinkCommand() {
    const command = new PlatformCommand('GmtCountryAnalysisDocumentViewerToolLinkCommand', Api.Chapters);
    return command;
  }

  private getGmtCountryAnalysisComparisonToolLinkCommand() {
    const command = new PlatformCommand('CreateGmtChapterComparisonReportCommand', Api.Chapters);
    command.fieldValues['DocumentDefinitionId'] = 'gmtcountryanalysis';
    command.projectId = '[PROJECT_ID]';
    return command;
  }

  private GetCbcComplianceCommand(scenarioType: string) {
    const command = new PlatformCommand('CbcComplianceChangesCommand', Api.DueDateTracker);
    command.projectId = '[PROJECT_ID]';
    if (scenarioType && scenarioType.length) {
      command.fieldValues['ScenarioType'] = scenarioType;
    }
    return command;
  }

  private getCreateOtpDataPlatformToolLinkCommandConsumer(scenarioType: string) {
    const command = new PlatformCommand('CreateOtpDataPlatformToolLinkCommand', 'FileStore');
    command.projectId = '[PROJECT_ID]';
    if (scenarioType && scenarioType.length) {
      command.fieldValues['ScenarioType'] = scenarioType;
    }
    return command;
  }

  private GetCreatCbcSupportedCountriesToolLinkCommand(api: string) {
    const command = new PlatformCommand('CbcSupportedCountriesToolLinkCommand', Api.Spreadsheet);
    command.projectId = '[PROJECT_ID]';
    return command;
  }

  private GetCreateCbCFilingToolLinkCommand(scenarioType: string) {
    const command = new PlatformCommand('CreateCbCFilingToolLinkCommand', Api.DueDateTracker);
    command.projectId = '[PROJECT_ID]';
    if (scenarioType && scenarioType.length) {
      command.fieldValues['ScenarioType'] = scenarioType;
    }
    return command;
  }

  private getGMTFilingFormPlatformLinkCommand() {
    const command = new PlatformCommand('GMTFilingFormToolLinkCommand', Api.Spreadsheet);
    return command;
  }

  private getPublicCbCFormPlatformLinkCommand() {
    const command = new PlatformCommand('PublicCbCFormToolLinkCommand', Api.Spreadsheet);
    return command;
  }

  private getTxpAdminPanelToolLinkCommand() {
    return new PlatformCommand('TxpAdminPanelToolLinkCommand', Api.Spreadsheet);
  }

  private getCreateWorkflowPlatformToolLinkCommandConsumer(scenarioType: string) {
    const command = new PlatformCommand('CreateWorkFlowToolLinkCommand', Api.Flow);
    command.fieldValues['ViewMode'] = 'IconView';
    command.fieldValues['ChildFolderName'] = 'Tax Provision';
    command.fieldValues['ScenarioType'] = scenarioType;
    command.fieldValues['ResponseWrapperService'] = 'EatDriveViewWrapperService';
    command.fieldValues['RedirectUrl'] = '/eat/txp/[LinkId]';
    return command;
  }
}
